<template>
  <div class="list-page-header">
    <h3 class="title">{{ this.$t("grade_scale.list_page_title") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success ml-6"
      @click.native.prevent="go2AddPage"
      >{{ $t("common.add_new") }}</md-button
    >
  </div>
</template>

<script>
import { grade_scale_router_names } from "@/routes/routes";
import { GradeScale } from "@/constants/Permissions";

export default {
  name: "list-page-header",
  computed: {
    canAdd() {
      return this.$can(GradeScale.actions.add, GradeScale.subject);
    }
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: grade_scale_router_names.addPage });
    }
  }
};
</script>
